import type { ToolCallPayload } from "../../api/threads/liveMessages";

/** The DMW tool an agent saves a memory with (memory.md MEM-4). */
export const SAVE_MEMORY_TOOL = "save_memory";

/** What an agent's successful `save_memory` call did, read from its record in the Thread. */
export interface AgentMemorySave {
  /** `active`: kept at once. `proposed`: waits for a person to confirm it. */
  readonly state: "active" | "proposed";
  /** Recorded only by calls from before memories were personal only (J-01 (a)); a call
   * now records no title, so a memory's title stays out of the Thread. */
  readonly title: string | null;
  /** The memory, as the call's result names it; its own Thread is read from it. */
  readonly memoryId: string | null;
}

/** The save a tool call records, or `null` for any other call and for one that failed. */
export function agentMemorySave(payload: ToolCallPayload): AgentMemorySave | null {
  if (payload.tool !== SAVE_MEMORY_TOOL || payload.outcome !== "ok") {
    return null;
  }
  const state = payload.result_summary["state"];
  if (state !== "active" && state !== "proposed") {
    return null;
  }
  const title = payload.arguments["title"];
  const memoryId = payload.result_summary["memory_id"];
  return {
    memoryId: typeof memoryId === "string" && memoryId !== "" ? memoryId : null,
    state,
    title: typeof title === "string" && title !== "" ? title : null,
  };
}
